var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container1"},[_c('span',{staticClass:"square"}),_vm._v("\n  "+_vm._s(_vm.cardtitle)+"\n  "),_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6046dc55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/cardTitle.vue
// module id = null
// module chunks = 